module.exports = __webpack_public_path__ + "static/img/investor_relations.73314ee.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/investorRelation/investor_relations.jpg
// module id = rCJm
// module chunks = 2